import React from "react";
import * as styles from "./OfferHighlights.module.scss";
import OfferHighlightCard from "./OfferHighlightCard";
import { OfferTokenValues } from "types/api/exclusive_offers.d";
import classNames from "classnames";
import { SanityBlock } from "types/graphql-types";
import { ComponentBackgroundColor } from "types/componentBackground";

export type OfferHighlight = {
  name: string | SanityBlock[];
  description: string | SanityBlock[];
  icon?: string;
};

export interface OfferHighlightsProps {
  title: string | undefined;
  offers: OfferHighlight[];
  tokenValues?: OfferTokenValues;
  variant?: "large" | "small";
  cardBackgroundColor?: ComponentBackgroundColor;
}

const OfferHighlights: React.FC<OfferHighlightsProps> = ({
  title,
  offers = [],
  tokenValues = {},
  variant = "large",
  cardBackgroundColor = "neutral05"
}) => {
  return (
    <section>
      {title && (
        <header className={styles.header}>
          <h4 className={styles.title}>{title}</h4>
        </header>
      )}
      <div
        className={classNames({
          [styles.offers]: true,
          [styles.variantLarge]: variant == "large",
          [styles.variantSmall]: variant == "small"
        })}
      >
        {offers.map((offer, index) => (
          <OfferHighlightCard
            key={index}
            offer={offer}
            tokenValues={tokenValues}
            backgroundColor={cardBackgroundColor}
          />
        ))}
      </div>
    </section>
  );
};

export default OfferHighlights;
